import endpoints from '../config/apiConfig';
import axiosInstance from '../config/axiosInstance';
import { AppointmentPayload } from '../types/calender';
import { ConsultationPayload } from '../types/consultation';
import { PatientPayload } from '../types/createUserForm';
import { PreviousDataParams } from '../types/payload';
import { PaginationParams } from '../types/table';

const createConsultation = (payload: ConsultationPayload) => {
  return axiosInstance.post(endpoints.createConsultation, payload);
};

const updateConsultation = (payload: ConsultationPayload) => {
  return axiosInstance.put(`${endpoints.updateConsultation}`, payload);
};

const getSingleConsultation = (caseId: string, uuid: string) => {
  return axiosInstance.get(
    `${endpoints.showSingleConsultation}/${caseId}/${uuid}`
  );
};

const getPastConsultation = (caseId: string) => {
  return axiosInstance.get(`${endpoints.pastConsultation}/${caseId}`);
};

const getDateSpecificConsultation = (caseNumber: string, date: string) => {
  return axiosInstance.get(endpoints.dateSpecificConsultation, {
    params: { case_number: caseNumber, date },
  });
};

const getUpcomingConsultation = (params: PaginationParams) => {
  return axiosInstance.get(`${endpoints.upcomingConsultation}`, { params });
};

const getTodaysConsultation = (params: AppointmentPayload) => {
  return axiosInstance.get(endpoints.todayConsultation, { params });
};
const getWeeksConsultation = (params: AppointmentPayload) => {
  return axiosInstance.get(endpoints.todayConsultation, { params });
};
const getMonthsConsultation = (params: AppointmentPayload) => {
  return axiosInstance.get(endpoints.todayConsultation, { params });
};
const getPreviousData = (params: PreviousDataParams) => {
  return axiosInstance.get(endpoints.loadPreviousData, { params });
};

const getPatentData = (
  caseId: string,
  uuid: string,
  withoutHeader: boolean = false
) => {
  return axiosInstance.get(
    `${
      endpoints.getPatentData
    }?print_for=consultation&caseId=${caseId}&consultation_uuid=${uuid}&print_type=${
      withoutHeader ? 'without_header' : 'with_header'
    }`
  );
};
const getPatient = (caseId: string) => {
  return axiosInstance.get(`${endpoints.getPatient}/${caseId}`);
};

const updatePatient = (caseId: string, payload: PatientPayload) => {
  return axiosInstance.put(`${endpoints.updatePatient}/${caseId}`, payload);
};
const getSingleAppointment = (uuid: string) => {
  return axiosInstance.get(`${endpoints.getSingleAppointment}/${uuid}`);
};
const getMainPaymentHistory = (caseId: string) => {
  return axiosInstance.get(`${endpoints.getMainPaymentHistory}/${caseId}`);
};

export {
  createConsultation,
  updateConsultation,
  getUpcomingConsultation,
  getTodaysConsultation,
  getWeeksConsultation,
  getMonthsConsultation,
  getSingleConsultation,
  getPastConsultation,
  getDateSpecificConsultation,
  getPreviousData,
  getPatentData,
  getPatient,
  updatePatient,
  getSingleAppointment,
  getMainPaymentHistory,
};
